import { render, staticRenderFns } from "./SubmitClaim.vue?vue&type=template&id=33cf2f34&scoped=true&"
import script from "./SubmitClaim.vue?vue&type=script&lang=js&"
export * from "./SubmitClaim.vue?vue&type=script&lang=js&"
import style0 from "./SubmitClaim.vue?vue&type=style&index=0&id=33cf2f34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cf2f34",
  null
  
)

export default component.exports